import { Box, CircularProgress } from "@mui/material";
import { setMobileTextColor } from "../utility";

const Loading = ({ backColor }) => {
  if (backColor) {
    return (
      <Box
        className={`vh-100 position-absolute w-100 h-100`}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: backColor }}
      >
        <CircularProgress sx={{ color: setMobileTextColor() }} />
      </Box>
    );
  }
  return (
    <Box
      className="vh-100 position-absolute w-100 h-100 secondary-background"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loading;
